import React, { useState, useEffect } from "react";
import useSettings from "stores/settings";
import { FormatDate } from "components/FormatDate";
// import Modal from "@material-ui/core/Modal";
// import ModalFade from "components/modal/ModalFade";
import MaterialModal from "components/modal/MaterialModal";
import IconButton from "@material-ui/core/IconButton";
// import Backdrop from "@material-ui/core/Backdrop";
import CloseIcon from "@material-ui/icons/Close";
// import { makeStyles } from "@material-ui/core/styles";

import { BasicAlert } from "components/Alert";
import { projectFirestore } from "components/ProjectFirestore";
import { projectStorage } from "components/ProjectStorage";
import CreateIcon from "@material-ui/icons/Create";
import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import TextField from "@material-ui/core/TextField";
import DeleteModal from "components/modal/DeleteModal";

// const useStyles = makeStyles({
//   modal: {
//     outline: 0, // add / remove
//   },
// });

/* 데이터 분석 앱 카드 */
const DataAnalysisAppCard = ({
  id,
  review,
  reviewedAt,
  updateData,
  setUpdateData,
  inputFile,
  outputFile,
  appId,
  email,
  appName,
  price,
  createdAt,
  inputType,
  category,
}) => {
  if (!id) return "실행 결과가 없습니다.";

  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisible2, setModalVisible2] = useState(false);

  const [getUrl, setGetUrl] = useState();
  const [downloadFileData, setDownloadFileData] = useState();

  useEffect(async () => {
    if (outputFile && category === "dataAnalysis") {
      const storageFileRef = projectStorage.ref(outputFile);
      storageFileRef
        .getDownloadURL()
        .then(function (url) {
          setGetUrl(url);
        })
        .catch(function (error) {
          console.log("error : ", error);
        });
    }
  }, []);
  useEffect(async () => {
    if (getUrl) {
      /** csv 파일 읽기 */
      const res = await fetch(getUrl);
      const result = await res.text();
      if (result !== "" && result.indexOf("<!DOCTYPE html><html><head>") === -1) {
        const rows = result.split("\n");
        const columnString = rows[0];
        const fieldString = rows[1];
        const column = columnString.replace(/(\")/g, "").split(",");
        const field = fieldString.replace(/(\")/g, "").split(",");

        /** 다운로드 받을 샘플 데이터 저장 */
        let tempDownloadFileData = "";
        column.map((m) => (tempDownloadFileData += m + ","));
        tempDownloadFileData = tempDownloadFileData.substring(0, tempDownloadFileData.length - 1);
        tempDownloadFileData += "\n";
        field.map((m) => (tempDownloadFileData += m + ","));
        tempDownloadFileData = tempDownloadFileData.substring(0, tempDownloadFileData.length - 1);

        setDownloadFileData(tempDownloadFileData);
      }
    }
  }, [getUrl]);

  /* 실행 결과 삭제 */
  const handleFileDelete = () => {
    setModalVisible2(true);
  };

  /* 후기 내용 추가 */
  const handleReviewModal = () => {
    setModalVisible(true);
  };

  /* 결과 파일 다운로드 */
  const handleFileDownload = () => {
    const fileName = `${appName}_${createdAt}.csv`;
    linkDownload(fileName, downloadFileData);
  };

  /** 파일 다운로드 */
  function linkDownload(filename, content) {
    const link = document.createElement("a");
    const contentType = "data:application/csv;charset=utf-8,";
    const uriContent = contentType + encodeURIComponent(content);
    link.setAttribute("href", uriContent);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <div className="app-content mt-4">
      <div className="aiso-card aiso-shadow">
        <div className="cursor-pointer">
          <div className="p-3">
            <div className="truncate-1-lines text-333 text-base font-gmarket-medium font-bold my-2">{appName}</div>
          </div>

          <div className="px-3">
            <p className="text-ss text-333 font-gmarket-medium">
              <span className="font-bold text-sm text-primary">{price}</span> Credit
            </p>
            <p className="mb-0 text-aaa font-gmarket-medium text-xs">{createdAt}</p>
          </div>
        </div>
        <div className="px-3 pt-3">
          <button type="" className="btn text-xs font-bold px-3 py-2" onClick={handleFileDownload}>
            결과 다운로드
          </button>
        </div>
        <div className="flex items-center justify-between pt-3">
          <div className="w-full flex">
            <button className="btn  w-1/2 font-bold text-xs" onClick={handleReviewModal} type="">
              {reviewedAt ? (
                <>
                  <CheckCircleOutline className="mr-2" /> 작성 완료
                </>
              ) : (
                <>
                  <CreateIcon className="mr-2" /> 후기 작성
                </>
              )}
            </button>
            <button className="btn w-1/2 font-bold text-xs" onClick={handleFileDelete} type="">
              <HighlightOffIcon className="mr-2" /> 삭제
            </button>
          </div>
        </div>
      </div>
      {/* Modal */}
      <DeleteModalContent
        modalVisible={modalVisible2}
        setModalVisible={setModalVisible2}
        docId={id}
        appEmail={email}
        appId={appId}
        reviewedAt={reviewedAt}
        updateData={updateData}
        setUpdateData={setUpdateData}
      />
      <ReviewContentModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        closeModal={() => setModalVisible(false)}
        id={id}
        email={email}
        review={review}
        reviewedAt={reviewedAt}
        updateData={updateData}
        setUpdateData={setUpdateData}
        appId={appId}
        appName={appName}
        inputFile={inputFile}
        outputFile={outputFile}
        inputType={inputType}
      />
    </div>
  );
};

/* 후기 등록 */
const ReviewContentModal = ({
  modalVisible,
  setModalVisible,
  closeModal,
  id,
  email,
  review,
  reviewedAt,
  updateData,
  setUpdateData,
  appId,
  appName,
  inputFile,
  outputFile,
  inputType,
}) => {
  const settings = useSettings();
  // const styles = useStyles();
  const [imageVisible, setImageVisible] = useState(false);
  const [reviewContent, setReviewContent] = useState("");
  const handleModalOkButton = () => {
    if (!reviewContent || reviewContent === "") {
      const text = "후기 내용을 입력해주세요.";
      BasicAlert(text);
      return "";
    }

    handleReviewSave();
  };
  const handleReviewSave = async () => {
    const date = new Date();
    const createdAt = FormatDate(date);

    /**
     * 1. contentsData update
     * 2. users 아래 후기 내용 저장
     * 3. 사용된 앱 아래 기록
     * 4. 앱 개발자 아래 기록
     */

    /* 1. 테이블 데이터 업데이트 */
    setUpdateData(!updateData);

    /* 2. 앱 사용자 아래 후기 내용 저장 */
    const updateValues = {
      review: reviewContent,
      reviewedAt: createdAt,
      imageVisible,
      visible: true,
    };
    try {
      const docRef = projectFirestore.collection("users").doc(`${settings.email}`).collection("history").doc(`${id}`);
      await docRef.set(updateValues, { merge: true });
    } catch (error) {
      console.error(error);
    }

    /* 3. 사용된 앱 아래 기록 */
    const newValues = {
      email: settings.email,
      userName: settings.name,
      appId: appId,
      appName: appName,
      review: reviewContent,
      createdAt,
      comment: "",
      commentedAt: "",
      inputFile: inputFile,
      outputFile: outputFile,
      imageVisible,
      visible: true,
    };
    try {
      const docRef = projectFirestore.collection("gcf").doc(`${email}`).collection("app").doc(`${appId}`).collection("review").doc(id);
      await docRef.set(newValues);
    } catch (error) {
      console.error(error);
    }

    /* 4. 앱 개발자 아래 기록 */
    try {
      const docRef = projectFirestore.collection("users").doc(`${email}`).collection("review").doc(`${id}`);
      await docRef.set(newValues);
    } catch (error) {
      console.error(error);
    }

    setModalVisible(false);
    setReviewContent("");
  };
  return (
    <MaterialModal open={modalVisible} closeModal={closeModal}>
      <div className="popup-content m-0 modal-width-180">
        <div className="popup-header">
          <IconButton aria-label="close" className="w-15 h-15" onClick={closeModal}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="popup-body flex flex-col justify-center items-center">
          {reviewedAt ? (
            <>
              <h5 className="text-333 font-gmarket-medium text-2xl font-bold center mb-4">후기 내용</h5>
              <div className="popup-body flex flex-col justify-center items-start">
                <div className="w-full mt-3">
                  <div>{review}</div>
                </div>
                <p className="w-full text-aaa mt-3">{reviewedAt}</p>
              </div>
              <div className="popup-footer center"></div>
            </>
          ) : (
            <>
              <div className="popup-body flex flex-col justify-center items-start">
                <h5 className="text-333 font-gmarket-medium text-2xl mb-0 font-bold">후기 작성</h5>
                <div className="w-full">
                  <TextField
                    // label="후기 내용"
                    placeholder="앱 실행 후기를 작성해주세요."
                    fullWidth
                    value={reviewContent}
                    onChange={(e) => setReviewContent(e.target.value)}
                    multiline
                    rows={5}
                    className="mt-4 w-full"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
                <p className="text-888 mb-0 py-3">등록 후 후기 내용은 변경할 수 없습니다.</p>
                {inputType && inputType === "csv" ? (
                  ""
                ) : (
                  <div className="form-check">
                    <label className="form-check-label">
                      <input type="checkbox" className="form-check-input" onChange={() => setImageVisible(!imageVisible)} />
                      <i className="input-helper">
                        <div style={{ fontStyle: "normal" }}>이미지 첨부 허용</div>
                      </i>
                    </label>
                  </div>
                )}
              </div>
              <div className="popup-footer center">
                <button type="button" className="btn btn-modal-o font-bold whitespace-nowrap" onClick={() => handleModalOkButton()}>
                  후기 등록
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </MaterialModal>
  );
};

/* 삭제 모달 */
const DeleteModalContent = ({ modalVisible, setModalVisible, docId, appEmail, appId, reviewedAt, updateData, setUpdateData }) => {
  const settings = useSettings();

  const handleResultRemove = async (docId) => {
    try {
      /* 1. history visible false */

      //FIXME: 우선 데이터만 삭제, 이후 실행 결과 파일 삭제 추가하기

      /* 결과 숨기기 */
      // const docRef = projectFirestore.collection("users").doc(settings.email).collection("history").doc(docId);
      // const values = { visible: false };
      // await docRef.update(values);

      /* 결과 삭제 */
      const docRef = projectFirestore.collection("users").doc(settings.email).collection("history").doc(docId);
      await docRef.delete();

      /* 후기 작성한 내용 있으면 삭제  */
      if (reviewedAt !== "") {
        const docRefDeveloper = projectFirestore.collection("users").doc(appEmail).collection("review").doc(docId);
        const docRefApp = projectFirestore.collection("gcf").doc(appEmail).collection("app").doc(appId).collection("review").doc(docId);
        await docRefDeveloper.delete();
        await docRefApp.delete();
      }

      /* 1. 테이블 데이터 업데이트 */
      setUpdateData(!updateData);

      setModalVisible(false);
    } catch (error) {
      console.log(error);
      BasicAlert("답변 에러");
    }
  };
  return (
    <DeleteModal
      modalVisible={modalVisible}
      closeModal={() => setModalVisible(false)}
      handleDeleteOkModal={() => handleResultRemove(docId)}
      target={`결과를`}
    />
  );
};

export default DataAnalysisAppCard;
